import request from '@/api/request'

/**
 * 通知类型枚举
 */
export enum NotificationType {
  ALL = 'all',
  SYSTEM = 'SYSTEM',
  APPROVAL = 'APPROVAL',
  TASK_REMINDER = 'TASK_REMINDER',
  WARNING = 'WARNING',
  BORROW = 'BORROW',
  RETURN = 'RETURN',
  STORAGE = 'STORAGE',
  PROCESSING = 'PROCESSING'
}

/**
 * 通知优先级枚举
 */
export enum NotificationPriority {
  NORMAL = 0,
  IMPORTANT = 1,
  URGENT = 2
}

/**
 * 通知优先级标签
 */
export const NotificationPriorityLabel: Record<NotificationPriority, string> = {
  [NotificationPriority.NORMAL]: '普通',
  [NotificationPriority.IMPORTANT]: '重要',
  [NotificationPriority.URGENT]: '紧急'
}

/**
 * 通知查询参数
 */
export interface NotificationQuery {
  unreadOnly?: boolean
  type?: string
  priority?: number
  page?: number
  pageSize?: number
}

/**
 * 通知列表项
 */
export interface NotificationItem {
  id: number
  notificationType: string
  notificationTypeName: string
  title: string
  content: string
  senderName?: string
  receiverId: number
  relatedType?: string
  relatedId?: number
  priority: number
  isRead: number
  readTime?: string
  actionType?: string
  actionUrl?: string
  expireTime?: string
  createTime: string
  unread: boolean
  expired: boolean
  important: boolean
  displayTime: string
}

/**
 * 分页响应
 */
export interface NotificationListResponse {
  list: NotificationItem[]
  total: number
}

/**
 * 创建通知表单
 */
export interface NotificationForm {
  notificationType: string
  title: string
  content: string
  senderId?: number
  senderName?: string
  receiverId: number
  receiverRole?: string
  relatedType?: string
  relatedId?: number
  priority?: number
  actionType?: string
  actionUrl?: string
  expireTime?: string
}

/**
 * 通知API
 */
export const notificationApi = {
  /**
   * 获取通知列表（分页）
   */
  list(params: NotificationQuery) {
    return request.get<NotificationListResponse>('/notifications/list', { params })
  },

  /**
   * 获取未读通知数量
   */
  getUnreadCount() {
    return request.get<number>('/notifications/unread-count')
  },

  /**
   * 标记通知为已读
   */
  markAsRead(id: number) {
    return request.post(`/notifications/${id}/read`)
  },

  /**
   * 批量标记为已读
   */
  batchMarkAsRead(ids: number[]) {
    return request.post<number>('/notifications/batch-read', ids)
  },

  /**
   * 标记全部为已读
   */
  markAllAsRead() {
    return request.post<number>('/notifications/read-all')
  },

  /**
   * 删除通知
   */
  delete(id: number) {
    return request.delete(`/notifications/${id}`)
  },

  /**
   * 删除所有通知
   */
  deleteAll() {
    return request.delete<number>('/notifications/all')
  },

  /**
   * 创建通知
   */
  create(data: NotificationForm) {
    return request.post<number>('/notifications/create', data)
  }
}
